<template>
  <div>
    <el-row
        v-show="product"
        :gutter="20"
        class="color-size-area">
      <el-form ref="form1"
          label-width="180px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="カラーグループ">
              <BaseCell
                  :properties="colorGroupProps"
                  :display-item="product"
                  :editable="editable('colorGroupCode')"
                  @change="colorGroupChanged" />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="カラー展開">
              <BaseCell
                  :properties="colorVariationProps"
                  :editable="editable('colorCode')"
                  :display-item="product"
                  @change="colorChanged" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="代表カラー">
              <BaseCell
                  :properties="mainColorProps"
                  :editable="editable('mainColorCode')"
                  :display-item="product" />
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="サイズグループ">
              <BaseCell
                  :properties="sizeGroupProps"
                  :display-item="product"
                  :editable="editable('sizeGroupCode')"
                  @change="sizeGroupChanged" />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="サイズ展開">
              <BaseCell
                  :properties="sizeVariationProps"
                  :editable="editable('sizeCode')"
                  :display-item="product"
                  @change="sizeChanged" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>

    <el-row :gutter="40">
      <el-tabs
          v-model="activeTabName"
          class="sku_tab">
        <el-tab-pane
            v-for="(sku, index) in skus"
            :key="`sku-${sku.color.code}-${sku.size.code}`"
            :name="`${sku.color.code}-${sku.size.code}`">
          <span slot="label">
            {{ sku.color.name && sku.size.name ? sku.color.name + ' ' + sku.size.name : sku.color.name + sku.size.name }}
            <el-button v-if="sku.id === null"
                v-show="showCopySkuButton"
                size="small"
                :disabled="disableCopySkuButton"
                @click="onSkuSearchClick(index)">
              他SKUからコピー
            </el-button>
          </span>
          <el-row
              :gutter="20"
              class="basic-info el-collapse-item">
            <el-col :span="12">
              <BaseTableDetail
                  :table-set-list="skuInfo1(sku)"
                  :display-item="sku"
                  :mode="mode"
                  :editable="skuEditable(sku)"
                  :is-copied-all="isCopiedAll"
                  :is-copied-sku="isCopiedSku(sku)"
                  :highlight-path-list="highlightPathList"
                  :highlight-sku-path-list="highlightSkuPathList"
                  validate-scope="skuInfo" />
            </el-col>
            <el-col :span="12">
              <BaseTableDetail
                  :table-set-list="skuInfo2(sku)"
                  :display-item="sku"
                  :mode="mode"
                  :editable="skuEditable(sku)"
                  :is-copied-all="isCopiedAll"
                  :is-copied-sku="isCopiedSku(sku)"
                  :highlight-path-list="highlightPathList"
                  :highlight-sku-path-list="highlightSkuPathList"
                  validate-scope="skuInfo" />
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <BaseDialog
        title="SKU検索"
        append-to-body
        width="90%"
        :visible.sync="searchSkusDialogVisible"
        :show-footer="false">
      <template slot="contents">
        <SearchSkus
            :search-mode="searchSkuMode"
            @sku-selected="skuSelected" />
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>
.el-form-item {
  margin: 0;
}

.el-row {
  margin-bottom: 20px;
}

.el-row.color-size-area {
  padding: 10px 0;
  overflow: hidden;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
}

.sku_tab {
  padding: 6px 15px;
  margin: 0px 10px 0px 10px;
  font-size: 14px;
  text-align: left;
  vertical-align: top;
  font-size: 14px;
  line-height: 30px;
  background-color: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
}
.sku_tab ::v-deep .base-cell input,
.sku_tab ::v-deep .base-cell i {
  height: 24px;
  line-height: 24px;
}

.sku_tab ::v-deep .base-cell button i {
  height: initial;
  line-height: initial;
}

.sku_tab ::v-deep .base-cell .el-tag--info {
  height: 20px;
  line-height: 20px;
}

.sku_tab ::v-deep .base-cell .el-tag--info i {
  height: 16px;
  line-height: 16px;
}

.sku_tab ::v-deep .el-tabs__header {
  margin: 0 -75px;
  padding: 0 60px;
  z-index: 200000;
  position: sticky;
  top: 226px;
}

.sku_tab ::v-deep .el-tabs__nav-wrap {
  background-color: #fff;
}

</style>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as define from '@/define'

import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import BaseDialog from '@/components/molecules/BaseDialog'
import SearchSkus from '@/components/pages/order/SearchSkus'
import utilProduct from '@/utils/product'
import compare from '@/utils/compareUtils'
import common from '@/utils/common'
import baseCellConvert from '@/utils/baseCellConvert'

const EDITABLE = Object.freeze({
  [define.MODE.NEW]: Object.freeze({
    colorGroupCode: true, mainColorCode: true, colorCode: true, sizeGroupCode: true, sizeCode: true
  }),
  [define.MODE.EDIT]: Object.freeze({
    colorGroupCode: true, mainColorCode: true, colorCode: true, sizeGroupCode: true, sizeCode: true
  })
})

const SKU_ROW_EDITABLE = Object.freeze({
  [define.MODE.NEW]: Object.freeze({
    code: true, name: true, jan: true, skuType: true, makerSku: true, ean: true,
    preparingShipmentStartedAt: true, releaseDatetime: true, displayOrder: true, minOrderQuantity: true, maxOrderQuantity: true,
    maxOrderableQuantityForUser: true, suggestedRetailPriceExTax: true, suggestedRetailPriceInTax: true,
    costExTax: true, priceExTax: true, priceInTax: true, salesPeriod: true, onlineDatetime: true,
    productDescription: true, productDetail: true,
    offlineDatetime: true, isBuyableOnly: true, isShipment: true, isInventoryControl: true, isSearchable: true, isSearchableIfUnavailable: true,
    attribute: true
  }),
  [define.MODE.EDIT]: Object.freeze({
    code: true, name: true, jan: true, skuType: true, makerSku: true, ean: true,
    preparingShipmentStartedAt: true, releaseDatetime: true, displayOrder: true, minOrderQuantity: true, maxOrderQuantity: true,
    maxOrderableQuantityForUser: true, suggestedRetailPriceExTax: true, suggestedRetailPriceInTax: true,
    costExTax: true, priceExTax: true, priceInTax: true, salesPeriod: true, onlineDatetime: true,
    productDescription: true, productDetail: true,
    offlineDatetime: true, isBuyableOnly: true, isShipment: true, isInventoryControl: true, isSearchable: true, isSearchableIfUnavailable: true,
    attribute: true
  })
})

const customValidationRules = (v) => {
  // 同一品番におけるSKUコードの重複
  v.$validator.extend('checkDuplicateSKUCode', {
    getMessage: () => 'SKUコードが同一のものが存在します。',
    validate: (value, args) => {
      if ((v.skus || []).filter((sku) => sku.code === value).length > 1) return false
      return true
    }
  })

  // 文字数のチェック
  v.$validator.extend('maxLengthSpecial', {
    getMessage: (name, args) => `${name}は${args[0]}文字以下である必要ああります。 ※ 全角：2文字扱い`,
    validate: (value, args) => {
      if (common.getLen(value) > Number(args[0])) return false
      return true
    }
  })
}

export default {
  name: 'ProductSku',
  components: {
    BaseCell,
    BaseTableDetail,
    BaseDialog,
    SearchSkus
  },
  inject: ['parentValidator'],
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: Number,
      default: define.MODE.NORMAL
    },
    originData: {
      type: Object,
      default: () => ({})
    },
    storePath: {
      type: String,
      required: true
    },
    highlightPathList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isCopiedAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeTab: null,
      searchSkusDialogVisible: false,
      activeSkuIndex: null,
      skuPropertyPathList: [],
      skuAttributePropertyPathList: [],
      highlightSkuPathList: {}
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      brandMaster: (state) => state.Product.brandMaster,
      colorMaster: (state) => state.Product.colorMaster,
      colorGroupMaster: (state) => state.Product.colorGroupMaster,
      sizeMaster: (state) => state.Product.sizeMaster,
      sizeGroupMaster: (state) => state.Product.sizeGroupMaster,
      customizeMaster: (state) => state.Product.customizeMaster
    }),
    ...mapGetters({
      skuTypeEditable: 'skuTypeEditable',
      skuUneditableItem: 'skuUneditableItem',
      productDefaultValue: 'productDefaultValue',
      skuNameAbbreviationMaxLength: 'skuNameAbbreviationMaxLength',
      skuCodeMaxLength: 'skuCodeMaxLength',
      skuTypeOptions: 'skuTypeOptions',
      productSkuReleaseDatetimeIsRequired: 'productSkuReleaseDatetimeIsRequired',
      skuEditableBySkuType: 'skuEditableBySkuType',
      productCopyExcludeKeys: 'productCopyExcludeKeys',
      productCopyHighlightKeys: 'productCopyHighlightKeys'
    }),
    ...mapGetters('ProductDetail', {
      productDetailProperties: 'productDetailProperties'
    }),
    // カスタマイズ属性の親権限キー
    parentPermissionKey () { return define.PermissionKeys.Product.Detail.Sku.ATTRIBUTE },
    editable () {
      // 編集 かつ 既に注文がある場合、サービスサイトで設定されている項目は編集不可にする
      return function (key) {
        return (EDITABLE[this.mode] || {})[key] || false
      }
    },
    showCopySkuButton () {
      return this.$isFunctionShown(define.PermissionKeys.Product.Detail.COPY_SKU)
    },
    disableCopySkuButton () {
      return this.$isFunctionDisabled(define.PermissionKeys.Product.Detail.COPY_SKU)
    },
    activeTabName: {
      // getter 関数
      get: function () {
        const tabIds = this.skus.map((sku) => `${sku.color.code}-${sku.size.code}`)

        if (tabIds.includes(this.activeTab)) {
          return this.activeTab
        } else {
          // 一番左のタブを表示する。
          return this.skus[0] ? `${this.skus[0].color.code}-${this.skus[0].size.code}` : ''
        }
      },
      // setter 関数
      set: function (val) {
        this.activeTab = val
      }
    },
    groupColors () {
      return (this.colorGroupMaster.find((element) => element.code === this.product.colorGroupCode) || {}).color || []
    },
    groupSizes () {
      return (this.sizeGroupMaster.find((element) => element.code === this.product.sizeGroupCode) || {}).size || []
    },
    selectedColors () {
      return this.groupColors.filter((element) => this.product.colorVariations.includes(element.code)) || []
    },
    colorGroupProps () {
      return { type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'colorGroupCode', filterable: true,
        selectCode: () => this.colorGroupMaster,
        codeName: (code) => {
          return (this.colorGroupMaster.find(element => code === element.code) || {}).name
        }
      }
    },
    colorVariationProps () {
      return { type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'colorVariations', multiple: true, filterable: true,
        selectCode: () => this.groupColors,
        codeName: (codes) => {
          return _.chain(this.groupColors)
            .filter((element) => _.find(codes, (val) => val === element.colorCode))
            .join(', ')
            .value()
        }
      }
    },
    mainColorProps () {
      return { type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'mainColorCode', filterable: true,
        selectCode: () => this.selectedColors,
        codeName: (code) => {
          return (this.selectedColors.find((element) => element.code.toString() === code.toString()) || {}).name
        }
      }
    },
    sizeGroupProps () {
      return { type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'sizeGroupCode', filterable: true,
        selectCode: () => this.sizeGroupMaster,
        codeName: (code) => {
          return (this.sizeGroupMaster.find(element => code === element.code) || {}).name
        }
      }
    },
    sizeVariationProps () {
      return { type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'sizeVariations', multiple: true, filterable: true,
        selectCode: () => this.groupSizes,
        codeName: (codes) => {
          return _.chain(this.groupSizes)
            .filter((element) => _.find(codes, (val) => val === element.colorCode))
            .join(', ')
            .value()
        }
      }
    },
    skus: function () {
      const skus = []
      const fkus = this.product.fkus || []
      fkus.forEach((fku) => {
        if (fku.isActive === 1) {
          fku.skus.forEach((sku) => {
            if (sku.isActive === 1) {
              skus.push(sku)
            }
          })
        }
      })

      return skus
    },
    skuInfo1 () {
      return function (sku) {
        const returnValue = [
          {
            label: 'SKUコード',
            properties: [ {
              type: 'String', path: 'code', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'code', validateRule: this.skuCodeMaxLength() != null
                ? `required|checkDuplicateSKUCode|regex:^[a-zA-Z0-9!-/:-@¥[-\`{-~]*$|max:${this.skuCodeMaxLength() || 0}`
                : `required|checkDuplicateSKUCode|regex:^[a-zA-Z0-9!-/:-@¥[-\`{-~]*$|max:50`,
              validateAs: 'SKUコード',
              funcId: define.PermissionKeys.Product.Detail.Sku.SKU_CODE,
              editableCondition: (displayItem) => {
                return _.get(displayItem, 'uuid', '') === ''
              }
            }]
          },
          {
            label: 'SKU表示名',
            properties: [ {
              type: 'String', path: 'name', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'name',
              funcId: define.PermissionKeys.Product.Detail.Sku.SKU_NAME
            }]
          },
          {
            label: 'SKU表示名（カナ）',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'skuNameKana',
              editableId: 'name',
              funcId: define.PermissionKeys.Product.Detail.Sku.NAME_KANA
            }]
          },
          {
            label: 'SKU名略称',
            properties: [ {
              type: 'String', path: 'skuNameAbbreviation', elementType: ELEMENT_TYPE.INPUT,
              editableId: 'name', validateAs: 'SKU名略称',
              validateRule: this.skuNameAbbreviationMaxLength() != null
                ? `maxLengthSpecial:${this.skuNameAbbreviationMaxLength() || 0}` : '',
              funcId: define.PermissionKeys.Product.Detail.Sku.ABBREVIATION_NAME
            }]
          },
          {
            label: 'JANコード',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'jan',
              editableId: 'jan',
              funcId: define.PermissionKeys.Product.Detail.Sku.JAN_CODE
            }]
          },
          {
            label: 'SKU商品種類',
            properties: [ {
              type: 'String', path: 'skuType', validateRule: 'required', validateAs: 'SKU商品種類',
              elementType: ELEMENT_TYPE.SELECT_BOX, editableId: 'skuType',
              codeName: 'm_product.sku_type',
              selectCode: () => {
                return this.skuTypeOptions.filter((opt) => {
                  return opt.selectable === '1' && opt.displayTarget === '1'
                })
              },
              funcId: define.PermissionKeys.Product.Detail.Sku.SKU_TYPE
            }]
          },
          {
            label: '他社SKUコード',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'makerSku',
              editableId: 'makerSku',
              funcId: define.PermissionKeys.Product.Detail.Sku.MAKER_SKU_CODE
            }]
          },
          {
            label: 'EANコード',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'ean',
              editableId: 'ean',
              funcId: define.PermissionKeys.Product.Detail.Sku.EAN_CODE
            }]
          },
          {
            label: '希望小売価格(税抜)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'suggestedRetailPriceExTax',
              editableId: 'suggestedRetailPriceExTax',
              funcId: define.PermissionKeys.Product.Detail.Sku.SUGGESTED_RETAIL_PRICE_EX_TAX
            }]
          },
          {
            label: '希望小売価格(税込)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'suggestedRetailPriceInTax',
              editableId: 'suggestedRetailPriceInTax',
              funcId: define.PermissionKeys.Product.Detail.Sku.SUGGESTED_RETAIL_PRICE_IN_TAX
            }]
          },
          {
            label: '原価(税抜)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'costExTax',
              editableId: 'costExTax',
              funcId: define.PermissionKeys.Product.Detail.Sku.COST_EX_TAX
            }]
          },
          {
            label: '価格(税抜)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'priceExTax',
              editableId: 'priceExTax',
              funcId: define.PermissionKeys.Product.Detail.Sku.NET_PRICE_EX_TAX
            }]
          },
          {
            label: '価格(税込)',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'priceInTax',
              editableId: 'priceInTax',
              funcId: define.PermissionKeys.Product.Detail.Sku.NET_PRICE_IN_TAX
            }]
          },
          {
            label: '発売日時',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'releaseDatetime',
              editableId: 'releaseDatetime',
              validateRule: this.productSkuReleaseDatetimeIsRequired ? 'required' : '', validateAs: '発売日時',
              funcId: define.PermissionKeys.Product.Detail.Sku.RELEASE_DATETIME,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          },
          {
            label: '出荷指示送信開始日',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'preparingShipmentStartedAt',
              editableId: 'preparingShipmentStartedAt',
              funcId: define.PermissionKeys.Product.Detail.Sku.PREPARING_SHIPMENT_STARTED_AT,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          },
          {
            label: 'SKU表示順',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'displayOrder',
              editableId: 'displayOrder',
              funcId: define.PermissionKeys.Product.Detail.Sku.DISPLAY_ORDER
            }]
          }
        ]

        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(this.parentPermissionKey)) {
          const fkuIndex = this.product.fkus.findIndex((fku) => fku.color.code === sku.color.code)
          const skuIndex = this.product.fkus.find((fku) => fku.color.code === sku.color.code)
            .skus.findIndex((arraySku) => arraySku.size.code === sku.size.code)

          // 商品種類共通のカスタマイズ属性
          let index = 1
          this.customizeMaster.filter((element) => {
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SKU.COMMON.LEFT)
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(sku, customizeObj, 'attributes', 'attribute',
              this.storePath, `ProductDetail/productDetail/fkus[${fkuIndex}]/skus[${skuIndex}]`, this.parentPermissionKey))

            index = customizeObj.displayOrder
          })

          // 商品種類のカスタマイズ対応
          index = 1
          this.customizeMaster.filter((element) => {
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SKU.PRODUCT_TYPE.LEFT.replace('{productType}', this.product.productType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(sku, customizeObj, 'attributes', 'attribute',
              this.storePath, `ProductDetail/productDetail/fkus[${fkuIndex}]/skus[${skuIndex}]`, this.parentPermissionKey))

            index = customizeObj.displayOrder
          })

          // SKU種類のカスタマイズ対応
          index = 1
          this.customizeMaster.filter((element) => {
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SKU.SKU_TYPE.LEFT.replace('{skuType}', sku.skuType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(sku, customizeObj, 'attributes', 'attribute',
              this.storePath, `ProductDetail/productDetail/fkus[${fkuIndex}]/skus[${skuIndex}]`, this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }
        return returnValue
      }
    },
    skuInfo2 () {
      return function (sku) {
        const returnValue = [
          {
            label: '最小注文数',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'minOrderQuantity',
              editableId: 'minOrderQuantity',
              funcId: define.PermissionKeys.Product.Detail.Sku.MIN_ORDER_QUANTITY
            }]
          },
          {
            label: '最大注文数',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'maxOrderQuantity',
              editableId: 'maxOrderQuantity',
              funcId: define.PermissionKeys.Product.Detail.Sku.MAX_ORDER_QUANTITY
            }]
          },
          {
            label: '同一注文者購入可能数',
            properties: [ {
              type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, path: 'maxOrderableQuantityForUser',
              editableId: 'maxOrderableQuantityForUser',
              funcId: define.PermissionKeys.Product.Detail.Sku.MAX_ORDERABLE_QUANTITY_FOR_USER
            }]
          },
          {
            label: '販売開始日',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE, path: 'salesPeriodFrom',
              editableId: 'salesPeriod',
              funcId: define.PermissionKeys.Product.Detail.Sku.SALES_PERIOD_FROM,
              dateFormat: 'YYYY/MM/DD'
            }]
          },
          {
            label: '販売終了日',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE, path: 'salesPeriodTo',
              editableId: 'salesPeriod',
              funcId: define.PermissionKeys.Product.Detail.Sku.SALES_PERIOD_TO,
              dateFormat: 'YYYY/MM/DD'
            }]
          },
          {
            label: 'オンラインフラグ',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isOnline',
              editableId: 'onlineDatetime',
              funcId: define.PermissionKeys.Product.Detail.Sku.IS_ONLINE
            }]
          },
          {
            label: 'オンライン日時',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'onlineDatetime',
              editableId: 'onlineDatetime',
              funcId: define.PermissionKeys.Product.Detail.Sku.ONLINE_DATETIME,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          },
          {
            label: 'オフライン日時',
            properties: [ {
              type: 'Date', elementType: ELEMENT_TYPE.DATE_TIME, path: 'offlineDatetime',
              editableId: 'offlineDatetime',
              funcId: define.PermissionKeys.Product.Detail.Sku.OFFLINE_DATETIME,
              dateFormat: 'YYYY/MM/DD HH:mm:ss'
            }]
          },
          {
            label: '商品説明',
            properties: [ {
              type: 'String', path: 'productDescription', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA,
              rows: 4, editableId: 'productDescription',
              class: 'multiLineTextBox', lineBreak: true,
              funcId: define.PermissionKeys.Product.Detail.Sku.DETAIL
            },
            {
              id: 'previewBtn',
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'previewBtn',
              icon: '', size: 'small', label: 'プレビュー',
              path: 'productDescription',
              click: this.htmlClick,
              funcId: define.PermissionKeys.Product.Detail.Sku.DETAIL
            }]
          },
          {
            label: '商品詳細',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.INPUT_TEXT_AREA, path: 'productDetail',
              editableId: 'productDetail',
              rows: 4, class: 'multiLineTextBox', lineBreak: true,
              funcId: define.PermissionKeys.Product.Detail.Sku.DETAIL
            },
            {
              id: 'previewBtn',
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'previewBtn',
              icon: '', size: 'small', label: 'プレビュー',
              path: 'productDetail',
              click: this.htmlClick,
              funcId: define.PermissionKeys.Product.Detail.Sku.DETAIL
            }]
          },
          {
            label: '単体販売可否',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isBuyableOnly',
              editableId: 'isBuyableOnly',
              funcId: define.PermissionKeys.Product.Detail.Sku.IS_BUYABLE_ONLY
            }]
          },
          {
            label: '出荷有無',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isShipment',
              editableId: 'isShipment',
              funcId: define.PermissionKeys.Product.Detail.Sku.IS_SHIPMENT
            }]
          },
          {
            label: '在庫管理有無',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isInventoryControl',
              editableId: 'isInventoryControl',
              funcId: define.PermissionKeys.Product.Detail.Sku.IS_INVENTORY_CONTROL
            }]
          },
          {
            label: '検索可否',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isSearchable',
              editableId: 'isSearchable',
              funcId: define.PermissionKeys.Product.Detail.Sku.IS_SEARCHABLE
            }]
          },
          {
            label: '販売不可時の検索可否',
            properties: [ {
              type: 'String', elementType: ELEMENT_TYPE.CHECK_BOX, path: 'isSearchableIfUnavailable',
              editableId: 'isSearchableIfUnavailable',
              funcId: define.PermissionKeys.Product.Detail.Sku.IS_SEARCHABLE_IF_UNAVAILABLE
            }]
          }
        ]

        // カスタマイズ属性を設定
        if (this.customizeMaster != null &&
          this.$isFunctionShown(this.parentPermissionKey)) {
          const fkuIndex = this.product.fkus.findIndex((fku) => fku.color.code === sku.color.code)
          const skuIndex = this.product.fkus.find((fku) => fku.color.code === sku.color.code)
            .skus.findIndex((arraySku) => arraySku.size.code === sku.size.code)

          // 商品種類共通のカスタマイズ属性
          let index = 1
          this.customizeMaster.filter((element) => {
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SKU.COMMON.RIGHT)
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(sku, customizeObj, 'attributes', 'attribute',
              this.storePath, `ProductDetail/productDetail/fkus[${fkuIndex}]/skus[${skuIndex}]`, this.parentPermissionKey))

            index = customizeObj.displayOrder
          })

          // 商品種類のカスタマイズ対応
          index = 1
          this.customizeMaster.filter((element) => {
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SKU.PRODUCT_TYPE.RIGHT.replace('{productType}', this.product.productType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(sku, customizeObj, 'attributes', 'attribute',
              this.storePath, `ProductDetail/productDetail/fkus[${fkuIndex}]/skus[${skuIndex}]`, this.parentPermissionKey))

            index = customizeObj.displayOrder
          })

          // SKU種類のカスタマイズ対応
          index = 1
          this.customizeMaster.filter((element) => {
            return (element.functionKey === define.CUSTOMIZE_PROPERTY_KEY.PRODUCT.SKU.SKU_TYPE.RIGHT.replace('{skuType}', sku.skuType))
          }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
          }).forEach((customizeObj) => {
            let emptyCellNum = customizeObj.displayOrder - index
            while (emptyCellNum > 1) {
              returnValue.push(utilProduct.getCustomizeEmptyColumn())
              emptyCellNum -= 1
            }
            returnValue.push(utilProduct.getCustomizeColumn(sku, customizeObj, 'attributes', 'attribute',
              this.storePath, `ProductDetail/productDetail/fkus[${fkuIndex}]/skus[${skuIndex}]`, this.parentPermissionKey))

            index = customizeObj.displayOrder
          })
        }
        return returnValue
      }
    },
    searchSkuMode () {
      return define.SEARCH_MODE.SKU
    }
  },
  beforeUpdate () {
    this.skus.forEach((sku) => {
      const properties = [].concat(this.skuInfo1(sku), this.skuInfo2(sku))
      const propertyArray = []
      const attributePropertyArray = []
      properties.forEach((properties) => {
        const property = properties.properties[0]
        let path = property.path || ''
        if ((typeof path === 'string' && path !== '') &&
        (properties.properties[0].funcId == null || !this.$isFunctionDisabled(properties.properties[0].funcId))) {
          const pathArray = path.split('.')
          // ドット区切りで分割して、通常項目か属性情報か判定
          // ex.
          // 通常項目：name→['name']
          // 属性情報：attributes.8.attrValue→['attributes','8','attrValue']
          if (pathArray.length > 1 && pathArray[0] === 'attributes') {
            // pathがドット区切りかつ分割した最初の要素が「attributes」→attributes
            attributePropertyArray.push(property)
          } else {
            propertyArray.push(property)
          }
        }
      })
      this.fetchProductDetailProperties({ propertyArray: propertyArray, type: 'sku' })
      this.fetchProductDetailProperties({ propertyArray: attributePropertyArray, type: 'skuAttribute' })
    })
  },
  created () {
    customValidationRules(this)
  },
  methods: {
    ...mapActions('ProductDetail', [
      'fetchProductDetailProperties'
    ]),
    getColorDisplayLabel: function (item) {
      if (item == null) {
        return ''
      }
      if (item.colorNameOnGroup) {
        return item.colorCode + ' ' + item.colorNameOnGroup
      } else {
        return item.colorCode + ' ' + item.colorName
      }
    },
    isCopiedSku (skuItem) {
      return skuItem.isCopied || false
    },
    skuEditable (skuItem) {
      // 新規、編集モード以外は編集不可で終了
      if (![define.MODE.NEW, define.MODE.EDIT].includes(this.mode)) return {}

      // SKUのIDが未設定の場合は新規モードとして処理を継続
      const mode = skuItem.id == null ? define.MODE.NEW : this.mode

      // 現在のモードに応じた編集可否定義を取得
      let returnValue = _.cloneDeep(SKU_ROW_EDITABLE[mode] || {})

      // 全ての項目を一旦、編集可にする
      if ([define.MODE.NEW, define.MODE.EDIT].includes(mode)) {
        // 表示プロパティを結合
        [].concat(this.skuInfo1(skuItem), this.skuInfo2(skuItem))
          .forEach((obj, data) => {
            if (_.get(obj, 'properties.0.editableId', null) != null) {
              _.set(returnValue, obj.properties[0].editableId, true)
            }
          })
      }
      // sku種類の編集権限を取得
      const skuEditable = this.skuTypeEditable(skuItem.skuType)

      // 編集 かつ SKU種類が編集可能なタイプでないときすべて編集不可にする
      if (mode === define.MODE.EDIT && !skuEditable) {
        Object.keys(returnValue).forEach((key) => {
          _.set(returnValue, [key], false)
        })
        // // 編集不可SKU種類の編集可項目設定にある項目は編集可に更新する
        this.skuEditableBySkuType(skuItem.skuType).forEach((key) => {
          _.set(returnValue, key, true)
        })
      }

      // 編集 かつ 既に注文がある場合、サービスサイトで設定されている項目は編集不可にする
      if (mode === define.MODE.EDIT && skuItem.isOrdered) {
        this.skuUneditableItem.forEach((key) => {
          _.set(returnValue, key, false)
        })
      }

      // モードごとの編集可否定義でfalseの場合は上書き
      Object.keys(SKU_ROW_EDITABLE[mode] || {}).forEach((key) => {
        if (!SKU_ROW_EDITABLE[mode][key]) _.set(returnValue, key, false)
      })

      return returnValue
    },
    colorGroupChanged: function (val, displayItem, path, oldVal) {
      // 変更前のカラー時にskuにデータがある場合、削除していいか確認する
      let isInput = false
      this.product.fkus.some((fku) =>
        fku.skus.some((sku, i) => {
          if (!compare.compare(this.createCompareSkuObject(sku), this.createCompareSkuEmptyObject())) {
            isInput = true
            return true
          }
        }))

      // 対象fkuを消す
      const deleteFkus = () => {
        this.product.mainColorCode = null
        this.product.colorVariations = []
        const deleteItem = []
        this.product.fkus.forEach((fku, j) => {
          if (!fku.isActive) {
            return
          }
          if (fku.id != null) {
            const deleteItemSku = []
            fku.skus.forEach((sku, i) => {
              if (!sku.isActive) {
                return
              }
              if (sku.id != null) {
                sku.isActive = 0
              } else {
                fku.skus.splice(i, 1)
              }
            })
            deleteItemSku.sort((a, b) => (a > b) ? -1 : 1)
              .forEach((index) => {
                fku.skus.splice(index, 1)
              })
            fku.isActive = 0
          } else {
            deleteItem.push(j)
          }
        })
        deleteItem.sort((a, b) => (a > b) ? -1 : 1)
          .forEach((index) => {
            this.product.fkus.splice(index, 1)
          })
      }

      if (!isInput) {
        deleteFkus()
        return
      }

      this.$confirm('入力のあるSKUが破棄されますがよろしいですか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        deleteFkus()
      }).catch(() => {
        this.product.colorGroupCode = oldVal
      })
    },
    sizeGroupChanged: function (val, displayItem, path, oldVal) {
      // 変更前のサイズ時にskuにデータがある場合、削除していいか確認する
      let isInput = false
      this.product.fkus.some((fku) =>
        fku.skus.some((sku, i) => {
          if (!compare.compare(this.createCompareSkuObject(sku), this.createCompareSkuEmptyObject())) {
            isInput = true
            return true
          }
        }))

      // 対象skuを消す
      const deleteFkus = () => {
        this.product.fkus.forEach((fku, j) => {
          if (!fku.isActive) {
            return
          }
          if (fku.id != null) {
            const deleteItem = []
            fku.skus.forEach((sku, i) => {
              if (!sku.isActive) {
                return
              }
              if (sku.id != null) {
                sku.isActive = 0
              } else {
                deleteItem.push(i)
              }
            })
            deleteItem.sort((a, b) => (a > b) ? -1 : 1)
              .forEach((index) => {
                fku.skus.splice(index, 1)
              })
          } else {
            fku.skus = []
          }
        })
      }

      if (!isInput) {
        deleteFkus()
        return
      }
      this.product.sizeVariations = []

      this.$confirm('入力のあるSKUが破棄されますがよろしいですか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        deleteFkus()
      }).catch(() => {
        this.product.sizeGroupCode = oldVal
      })
    },
    sizeChanged: function (val, displayItem, path, oldVal) {
      let targetSize = null

      let isAdd = false
      let isDelete = false
      val.concat(oldVal)
        .forEach(item => {
          if (val.includes(item) && !oldVal.includes(item)) {
            isAdd = true
            targetSize = item
          } else if (!val.includes(item) && oldVal.includes(item)) {
            isDelete = true
            targetSize = item
          }
        })
      if (isAdd) {
        // 追加時
        // サイズ展開に入力がある場合、バリエーションの値からSKUを作成する
        this.product.fkus.filter((fku) => fku.isActive).forEach((fku) => {
          const existSku = fku.skus.find((sku) => sku.size.code === targetSize)
          if (existSku != null) {
            existSku.isActive = 1
          } else {
            const sku = this.createAddSkuObject(fku.color.code, targetSize)
            fku.skus.push(sku)
          }
        })
      } else if (isDelete) {
        // 削除時、対象データにデータがある場合、削除していいか確認する
        let isInput = false
        this.product.fkus.some((fku) =>
          fku.skus.some((sku, i) => {
            const isChanged = !compare.compare(this.createCompareSkuObject(sku),
              this.createCompareSkuEmptyObject())
            if (sku.size.code === targetSize && isChanged) {
              isInput = true
              return true
            }
          }))

        // 対象skuを消す
        const deleteSkus = () => {
          this.product.fkus.forEach((fku) => {
            fku.skus.some((sku, i) => {
              if (sku.size.code === targetSize) {
                if (sku.id != null) {
                  sku.isActive = 0
                } else {
                  fku.skus.splice(i, 1)
                }
                return true
              }
            })
          })
        }
        if (!isInput) {
          deleteSkus()
          return
        }
        this.$confirm('入力のあるSKUが破棄されますがよろしいですか？', define.MESSAGE_TITLE, {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }).then(() => {
          deleteSkus()
        }).catch(() => {
          this.product.sizeVariations = oldVal
        })
      }
    },
    colorChanged: function (val, displayItem, path, oldVal) {
      let targetColor = null

      let isAdd = false
      let isDelete = false
      val.concat(oldVal)
        .forEach(item => {
          if (val.includes(item) && !oldVal.includes(item)) {
            isAdd = true
            targetColor = item
          } else if (!val.includes(item) && oldVal.includes(item)) {
            isDelete = true
            targetColor = item
          }
        })
      if (isAdd) {
        // 追加時
        // カラー展開に入力がある場合、バリエーションの値からSKUを作成する
        let existFku = this.product.fkus.find((fku) => fku.color.code === targetColor)

        if (existFku != null) {
          existFku.isActive = 1
          existFku.skus.find((sku) => {})

          this.product.sizeVariations.forEach((size) => {
            const existSku = existFku.skus.find((sku) => sku.size.code === size)
            if (existSku != null) {
              existSku.isActive = 1
            } else {
              existFku.skus.push(this.createAddSkuObject(targetColor, size))
            }
          })
        } else {
          const fku = {
            id: null,
            isActive: 1,
            skus: [],
            color: { code: targetColor, name: this.groupColors.find((val) => val.code === targetColor).name },
            images: []
          }
          this.product.fkus.push(fku)
          const skus = []

          this.product.sizeVariations.forEach((size) => {
            skus.push(this.createAddSkuObject(targetColor, size))
          })
          fku.skus = skus
        }
      } else if (isDelete) {
        // 削除時、対象データにデータがある場合、削除していいか確認する
        let isInput = false
        this.product.fkus.some((fku) =>
          fku.skus.some((sku, i) => {
            const isChanged = !compare.compare(this.createCompareSkuObject(sku),
              this.createCompareSkuEmptyObject())
            if (sku.color.code === targetColor && isChanged) {
              isInput = true
              return true
            }
          }))

        // 対象fkuを消す
        const deleteSkus = () => {
          this.product.fkus.some((fku, i) => {
            if (fku.color.code === targetColor) {
              if (fku.id != null) {
                fku.isActive = 0
                fku.skus.forEach((sku) => {
                  sku.isActive = 0
                })
                return false
              } else {
                this.product.fkus.splice(i, 1)
                return true
              }
            }
          })
          // 代表カラーに選択していた場合、代表カラーを空にする
          if (this.product.mainColorCode === targetColor) {
            this.product.mainColorCode = null
          }
        }

        if (!isInput) {
          deleteSkus()
          return
        }

        this.$confirm('入力のあるSKUが破棄されますがよろしいですか？', define.MESSAGE_TITLE, {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }).then(() => {
          deleteSkus()
        }).catch(() => {
          this.product.colorVariations = oldVal
        })
      }
    },
    createAddSkuObject: function (colorCode, sizeCode) {
      return {
        id: null,
        isActive: 1,
        code: '',
        jan: '',
        makerSku: '',
        ean: '',
        preparingShipmentStartedAt: null,
        releaseDatetime: null,
        minOrderQuantity: '',
        maxOrderQuantity: '',
        maxOrderableQuantityForUser: '',
        suggestedRetailPriceExTax: '',
        suggestedRetailPriceInTax: '',
        costExTax: '',
        priceExTax: '',
        priceInTax: '',
        skuType: '',
        productDetail: '',
        productDescription: '',
        color: { code: colorCode, name: (this.groupColors.find((val) => val.code === colorCode) || {}).name },
        size: { code: sizeCode, name: (this.groupSizes.find((val) => val.code === sizeCode) || {}).name },
        isBuyableOnly: 1,
        isShipment: 1,
        isInventoryControl: 1,
        isSearchable: 1,
        isSearchableIfUnavailable:
          this.productDefaultValue.sku_is_searchable_if_unavailable != null
            ? Number(this.productDefaultValue.sku_is_searchable_if_unavailable) : 1,
        attributes: []
      }
    },
    createCompareSkuObject: function (sku) {
      return {
        code: sku.code,
        jan: sku.jan,
        makerSku: sku.makerSku,
        ean: sku.ean,
        preparingShipmentStartedAt: sku.preparingShipmentStartedAt,
        releaseDatetime: sku.releaseDatetime,
        minOrderQuantity: sku.minOrderQuantity,
        maxOrderQuantity: sku.maxOrderQuantity,
        maxOrderableQuantityForUser: sku.maxOrderableQuantityForUser,
        suggestedRetailPriceExTax: sku.suggestedRetailPriceExTax,
        suggestedRetailPriceInTax: sku.suggestedRetailPriceInTax,
        costExTax: sku.costExTax,
        skuType: sku.skuType,
        priceExTax: sku.priceExTax,
        priceInTax: sku.priceInTax,
        attributes: sku.attribute
      }
    },
    createCompareSkuEmptyObject: function () {
      return {
        code: '',
        jan: '',
        makerSku: '',
        ean: '',
        preparingShipmentStartedAt: '',
        releaseDatetime: '',
        minOrderQuantity: '',
        maxOrderQuantity: '',
        maxOrderableQuantityForUser: '',
        suggestedRetailPriceExTax: '',
        suggestedRetailPriceInTax: '',
        costExTax: '',
        priceExTax: '',
        priceInTax: '',
        productDetail: '',
        productDescription: '',
        attributes: []
      }
    },
    htmlClick (event, displayItem, displayValue) {
      this.$store.dispatch({
        type: 'set',
        states: {
          [`${this.storePath}/htmlPreviewDialogVisible`]: true,
          [`${this.storePath}/htmlPreviewDialogContent`]: displayValue
        }
      })
    },
    onSkuSearchClick (index) {
      // 選択したSKUのindexをセット
      this.activeSkuIndex = index
      this.searchSkusDialogVisible = true
    },
    /**
     * SKU情報を設定
     * @param {*} row SKU情報
     */
    skuSelected (row) {
      const fkus = this.product.fkus || []
      let fkuIndex = 0
      let skuIndex = 0
      let skuCount = 0
      let loopEnd = false

      // 選択したコピー先SKUのindexからFKU、SKUのindexをそれぞれ取得し、何番目のSKUにコピーするか判別
      for (const fku of fkus) {
        for (const sku of fku.skus) {
          if (sku.isActive === 1 && fku.isActive === 1) {
            if (skuCount === this.activeSkuIndex) {
              loopEnd = true
              break
            }
            skuCount++
          }
          if (fku.skus.length - 1 === skuIndex) {
            skuIndex = 0
          } else {
            skuIndex++
          }
        }
        if (loopEnd === true) {
          break
        }
        fkuIndex++
      }

      // デフォルトでコピー対象外とするキー
      const defaultExcludeSkuKeys = [
        'code'
      ]

      // SKU種類によって属性情報の表示が可変となるため、先にセット
      _.set(this.product.fkus[fkuIndex].skus[skuIndex], 'skuType', _.get(row, 'skuType'))
      // 以降callbackを延期し、DOMの更新サイクル後に実行
      this.$nextTick(() => {

        // サービスサイト設定よりコピー対象から除外する項目を取得
        const excludeSkuKeys = defaultExcludeSkuKeys.concat(this.productCopyExcludeKeys('sku'))
        const excludeSkuAttributeKeys = this.productCopyExcludeKeys('skuAttribute')

        const sku = this.product.fkus[fkuIndex].skus[skuIndex]
        const properties = [].concat(this.skuInfo1(sku), this.skuInfo2(sku))
        const propertyArray = []
        const attributePropertyArray = []
        properties.forEach((properties) => {
          const property = properties.properties[0]
          let path = property.path || ''
          if ((typeof path === 'string' && path !== '') &&
          (properties.properties[0].funcId == null || !this.$isFunctionDisabled(properties.properties[0].funcId))) {
            const pathArray = path.split('.')
            // ドット区切りで分割して、通常項目か属性情報か判定
            // ex.
            // 通常項目：name→['name']
            // 属性情報：attributes.8.attrValue→['attributes','8','attrValue']
            if (pathArray.length > 1 && pathArray[0] === 'attributes') {
              // pathがドット区切りかつ分割した最初の要素が「attributes」→attributes
              attributePropertyArray.push(property)
            } else {
              propertyArray.push(property)
            }
          }
        })
        this.fetchProductDetailProperties({ propertyArray: propertyArray, type: 'sku' })
        this.fetchProductDetailProperties({ propertyArray: attributePropertyArray, type: 'skuAttribute' })

        // 実行権限があり、サービスサイト設定．コピー対象外項目に含まれない項目
        const skuProperties = this.productDetailProperties.sku
        const skuAttributeProperties = this.productDetailProperties.skuAttribute
        const skuPathList = skuProperties
          .map((property) => property.path)
          .filter(function (v) { return !excludeSkuKeys.includes(v) })
        const skuAttributePathList = skuAttributeProperties
          .map((property) => property.editableId)
          .filter(function (v) { return !excludeSkuAttributeKeys.includes(v) })

        // コピー対象外キー＋ハイライトキーをハイライト対象とする。
        const highlightSkuKeys = excludeSkuKeys.concat(this.productCopyHighlightKeys('sku'))
        const highlightSkuAttributeKeys = excludeSkuAttributeKeys.concat(this.productCopyHighlightKeys('skuAttribute'))

        // ハイライト項目判定用のパスリストをprops(SKU)
        this.highlightSkuPathList = {
          'path': highlightSkuKeys,
          'attributePath': highlightSkuAttributeKeys
        }
        // SKU検索ダイアログで選択したSKUをコピー先データにセット
        Object.keys(row).forEach((key) => {
          if (skuPathList.includes(key)) {
            if (skuProperties.some(val => val.elementType === 'Number' &&
              val.path === key)) {
              const property =
                skuProperties.find(function (v) { return v.path === key })
              _.set(row, key, baseCellConvert.toHalfWidthNumber((_.get(row, key)), property.precision))
            }
            // 実行権限があり、サービスサイト設定．コピー対象外項目に含まれない項目をセット
            _.set(this.product.fkus[fkuIndex].skus[skuIndex], key, _.get(row, key))
          } else if (key === 'attributes') {
            // attrValueが空、かつ実行権限の項目、かつ除外項目でない属性をセット
            _.set(this.product.fkus[fkuIndex].skus[skuIndex], key,
              row.attributes.filter(val => 'attrValue' in val && val.attrValue != null && skuAttributePathList.includes(val.attrId))
                .map(function (val) {
                  // コピー対象から取得される「'1'/'0'」は1,0に変換
                  // (チェックボックス項目にセットした際に文字列だと正常に機能しないため。)
                  if (val.attrValue === '1') {
                    return { 'attrId': val.attrId, 'attrValue': 1 }
                  } else if (val.attrValue === '0') {
                    return { 'attrId': val.attrId, 'attrValue': 0 }
                  } else {
                    return val
                  }
                }
                ))
          }
        })
        // コピー対象のタブを特定するためのフラグをセット
        _.set(this.product.fkus[fkuIndex].skus[skuIndex], 'isCopied', true)
      })
      this.searchSkusDialogVisible = false
    }
  }
}
</script>
